import { ReactElement, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Loader } from "@screencloud/screencloud-ui-components";
import { Redirect } from "react-router-dom";
import { ErrorState, ViewerStore } from "../../types";
import { RootState } from "../../reducers";
import { LoginButtonType } from "../../components/LoginButton/LoginButton";
import "./Login.scss";
import Auth from "../../components/Auth/Auth";
import { getParametersFromUrl } from "../../utils/stringUtils";
import { getViewerChannel } from "../../actions";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";

const Login = (): ReactElement<{}> => {
  const dispatch = useDispatch();
  const viewer: ViewerStore = useSelector((state: RootState) => state.viewer);

  const [redirectUrl, setRedirectUrl] = useState<string>("/");

  useEffect(() => {
    const redirectUrl = new URLSearchParams(window.location.search).get(
      "redirectUrl"
    );
    setRedirectUrl(redirectUrl || "/");
  }, []);

  useEffect(() => {
    if (redirectUrl && !viewer.channel) {
      const { orgId, spaceId, channelId } = getParametersFromUrl(redirectUrl);
      if (orgId.length > 0 && spaceId.length > 0 && channelId.length > 0) {
        dispatch(getViewerChannel({ orgId, spaceId, channelId }));
      }
    }
  }, [redirectUrl, viewer.channel, dispatch]);

  return viewer.channel !== null && viewer.token !== null ? (
    <Redirect to={redirectUrl} />
  ) : viewer.channel !== null ? (
    <div className="login-page">
      <div className="login-error">
        {viewer.errors.length > 0 &&
          viewer.errors.map((error) =>
            error.error !== ErrorState.FailedToVerifyPassword ? (
              <ErrorMessage key={error.uuid} error={error} />
            ) : null
          )}
      </div>
      <div className="logo">
        <img src="logo.svg" alt="ScreenCloud Logo" />
        ScreenCloud
      </div>
      {viewer.channel && (
        <Auth stream={viewer.channel} buttonType={LoginButtonType.Provider} />
      )}
    </div>
  ) : (
    <div className="login-page">
      <Loader size="large" active inline="centered" className="auth-spinner" />
    </div>
  );
};

export default Login;
